import React, { memo, useCallback } from 'react';

import { graphql, createRefetchContainer } from 'react-relay';

// components
import { Tabs, Tab } from 'material-ui/Tabs';
import { List } from 'material-ui/List';
import CategoriesListItem from './CategoriesListItem';

const CategoriesEditor = memo(props => {
	const { relay, viewer } = props;
	const currentTab = viewer.section.id;

	const onTabChange = useCallback(
		value => {
			relay.refetch({ section: value }, null);
			// update current url without react-router using
			history.replaceState(null, '', `/categories/${value}`);
		},
		[currentTab],
	);

	const handleUpdate = useCallback(() => {
		relay.refetch({ section: currentTab }, null);
	}, [currentTab]);

	return (
		<React.Fragment>
			<Tabs tabItemContainerStyle={{ background: 'white' }} inkBarStyle={{ background: '#542376' }} value={currentTab} onChange={onTabChange}>
				{viewer.sections.edges.map(edge => (
					<Tab
						key={edge.node.id}
						value={edge.node.id}
						buttonStyle={{ fontSize: '14px', fontWeight: 500, color: 'black' }}
						label={edge.node.name}
					/>
				))}
			</Tabs>
			<List disablePadding>
				{viewer.categories.edges.map(edge => (
					<CategoriesListItem onUpdate={handleUpdate} key={edge.node.id} relay={relay} {...edge.node} />
				))}
			</List>
		</React.Fragment>
	);
});

export default createRefetchContainer(
	CategoriesEditor,
	graphql`
		fragment CategoriesEditor_viewer on Viewer @argumentDefinitions(section: { type: "ID!" }) {
			id
			categories(first: -1, section: $section) {
				edges {
					node {
						id
						name
						hidden
						slug
						section
						seoTitle
						seoKeywords
						seoDescription
					}
				}
			}
			sections {
				edges {
					node {
						id
						name
						hidden
					}
				}
			}
			section(id: $section) {
				id
			}
		}
	`,
	graphql`
		query CategoriesEditorRefetchQuery($section: ID!) {
			viewer {
				...CategoriesEditor_viewer @arguments(section: $section)
			}
		}
	`,
);



// WEBPACK FOOTER //
// src/components/categories/CategoriesEditor.js